
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MandelbrotSetEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         // Performance-friendly approximation using iterative shapes
        const iterations = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * 0.2 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;
        ctx.strokeStyle = pc.color;

        const draw = () => {
            ctx.save();
            ctx.translate(-width * 0.2, 0); // Center adjustment
            for (let i = 0; i < iterations; i++) {
                const s = Math.pow(0.8, i) * 300 * scale * (1 / (layerIndex + 1));
                const x = Math.sin(curTime + i) * 20;
                const y = Math.cos(curTime + i) * 20;
                
                ctx.beginPath();
                ctx.ellipse(x, y, s, s * 0.7, Math.sin(curTime * 0.1) * Math.PI, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
